import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Navigation } from './components/Navigation';
import { Header } from './components/Header';
import { About } from './components/About';
import { Values } from './components/Values';
import { Portfolio } from './components/Portfolio';
import { ApproachTimeline } from './components/ApproachTimeline';
import { AchievementsSection } from './components/AchievementsSection';
import { IndustryPresence } from './components/IndustryPresence';
import { ContactForm } from './components/ContactForm';
import { Footer } from './components/Footer';
import { Background } from './components/Background';
import { ScrollProgress } from './components/ScrollProgress';
import { ArticlePage } from './components/ArticlePage';
import { SkillPage } from './components/SkillPage';
import { PortfolioPage } from './components/PortfolioPage';
import './styles/glass.css';

const MainLayout: React.FC = () => {
  return (
    <>
      <ScrollProgress />
      <Background />
      <div className="shell">
        <Navigation />
        <Header />
        <About />
        <Values />
        <Portfolio />
        <ApproachTimeline />
        <AchievementsSection />
        <IndustryPresence />
        <ContactForm />
        <Footer />
      </div>
    </>
  );
};

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<MainLayout />} />
        <Route path="/portfolio" element={<PortfolioPage />} />
        <Route path="/article/:id" element={<ArticlePage />} />
        <Route path="/skill/:skillSlug" element={<SkillPage />} />
      </Routes>
    </Router>
  );
};

export default App;
